export default "__VITE_ASSET__BFiIdKk5__"